angular.module('mobilezuz').directive("confirmPassword", function() {
    return {
        require: "ngModel",
        scope: {
            confirmPassword: "=confirmPassword"
        },
        link: function(scope, element, attributes, modelVal) {
            modelVal.$validators.equal = function(val) {
                return val == scope.confirmPassword;
            };

            scope.$watch("confirmPassword", function() {
                modelVal.$validate();
            });
        }
    };
});